// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03346f77","666":"308f8da1","749":"648842a1","884":"856dab0f","903":"a73f8992"}[chunkId] + ".chunk.js";
};